"use client";

import { useTranslations } from "next-intl";
import { useAuthDialogStore } from "@/features/user/ui/store";
import { Button } from "@/ui";

/**
 * SignInButton component - Sign in button
 */
export const SignInButton = () => {
  const { toggleAuthDialog } = useAuthDialogStore();
  const usersT = useTranslations("users");

  return (
    <Button
      variant="ghost"
      onClick={() => toggleAuthDialog(true)}
      className="px-1 sm:px-2"
      data-testid="sign-in-trigger"
    >
      {usersT("sign_in")}
    </Button>
  );
};
